<footer class="content">
    <div class="container">

        <div class="row">
            <div class="col-lg-3 col-md-6">
                <p class="bold">
                    {{ translation?.contact_text_ln2 }}:
                </p>

                <p>
                    {{ translation?.contact_phone }}<br>
                    <a href="mailto:{{ translation?.contact_mail }}">{{ translation?.contact_mail }}</a><br>
                </p>

                <p>
                    <a href="https://files.efs-ag.services/EFS-IT-Support.vcf">{{ translation?.contact_vcf }}</a>
                </p>

                <p>
                    <a href="{{ translation?.fastclient_link }}">{{ translation?.fastclient_text }}</a>
                </p>
            </div>
            <div class="col-lg-3 col-md-6">

                <p class="bold">
                    {{ translation?.hr }}:
                </p>
                <div [innerHTML]="personalFooter"></div>


            </div>
            <div class="col-lg-3 col-md-6">
                <div [innerHTML]="contractFooter"></div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div [innerHTML]="securityFooter"></div>
            </div>

            <div class="col-lg-12 mt-2">
                <div class="divider"></div>
                <p class="mt-3 text-center">
                    <span class="bold">{{ translation?.support_text }}:</span><br>
                    {{ translation?.support_ln1 }}<br>
                    {{ translation?.support_ln2 }}
                </p>
            </div>
        </div>
    </div>
</footer>